'use client';

import { Box } from '@coolblue-development/freddy';
import { ProductSummary } from '@features/add-to-cart-page/typings/Product';

import AddToCartSections from '../Sections/AddToCartSections';
import { useAddToCartSteps } from './AddToCartStepsProvider';

type Props = {
  product: ProductSummary;
  isAddedAsSubscription: boolean;
  isBusinessCustomer: boolean;
  shouldUsePromotionalContent: boolean;
};

export function AddToCartStepsContent({
  product,
  isAddedAsSubscription,
  isBusinessCustomer,
  shouldUsePromotionalContent
}: Props) {
  const { steps, selectedStep } = useAddToCartSteps();

  return (
    <>
      {steps.map((sections, index) => (
        <Box key={index} display={index === selectedStep ? 'block' : 'none'}>
          <AddToCartSections
            product={product}
            sections={sections}
            isAddedAsSubscription={isAddedAsSubscription}
            isBusinessCustomer={isBusinessCustomer}
            shouldUsePromotionalContent={shouldUsePromotionalContent}
          />
        </Box>
      ))}
    </>
  );
}
